import { createContext, useContext, useMemo, useState } from 'react';
import { flushSync } from 'react-dom';
import { loginUser, logoutUser, readSession, signupUser } from './auth';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => readSession());

  const value = useMemo(
    () => ({
      user,
      isLoggedIn: Boolean(user?.id),
      async login(credentials) {
        const next = await loginUser(credentials);
        flushSync(() => setUser(next));
        return next;
      },
      async signup(details) {
        const next = await signupUser(details);
        flushSync(() => setUser(next));
        return next;
      },
      logout() {
        logoutUser();
        flushSync(() => setUser(null));
      },
    }),
    [user]
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
}
